import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

const router = new Router({
  mode: 'hash',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: function (resolve) {
        require(['components/views/login/login'], resolve)
      }
    },
    {
      path: '/quickLogin',
      name: 'quickLogin',
      component: function (resolve) {
        require(['components/views/login/quickLogin'], resolve)
      }
    },
    {
      path: '/error',
      name: 'Error',
      component: function (resolve) {
        require(['components/views/error/index'], resolve)
      },
      meta: {
        title: '错误页面'
      }
    },
    {
      path: '/settingPwd',
      name: 'settingPwd',
      component: function (resolve) {
        require(['components/views/login/settingPwd'], resolve)
      }
    },
    {
      path: '/forgetPwd',
      name: 'forgetPwd',
      component: function (resolve) {
        require(['components/views/login/forgetPwd'], resolve)
      }
    },
    {
      path: '/userCenter',
      name: 'UserCenter',
      component: function (resolve) {
        require(['components/views/me/userCenter'], resolve)
      }
    },
    {
      path: '/agreement',
      name: 'Agreement',
      component: function (resolve) {
        require(['components/views/user/agreement'], resolve)
      }
    },
    {
      path: '/privateAgreement',
      name: 'PrivateAgreement',
      component: function (resolve) {
        require(['components/views/user/privateAgreement'], resolve)
      }
    },
    {
      path: '/aboutUs',
      name: 'AboutUs',
      component: function (resolve) {
        require(['components/views/me/aboutUs'], resolve)
      }
    },
    {
      path: '/realName',
      name: 'RealName',
      component: function (resolve) {
        require(['components/views/me/realName'], resolve)
      }
    },
    {
      path: '/modifyPassword',
      name: 'ModifyPassword',
      component: function (resolve) {
        require(['components/views/me/modifyPassword'], resolve)
      }
    },
    {
      path: '/latestAnnouncement',
      name: 'LatestAnnouncement',
      component: function (resolve) {
        require(['components/views/me/latestAnnouncement'], resolve)
      }
    },
    {
      path: '/announcementDetail/:announcementInfo',
      name: 'AnnouncementDetail',
      component: function (resolve) {
        require(['components/views/me/announcementDetail'], resolve)
      }
    },
    {
      path: '/setting',
      name: 'Setting',
      component: function (resolve) {
        require(['components/views/me/setting'], resolve)
      }
    },
    {
      path: '/commonProblemList',
      name: 'CommonProblemList',
      component: function (resolve) {
        require(['components/views/me/commonProblemList'], resolve)
      }
    },
    {
      path: '/commonProblems/:problemInfo',
      name: 'CommonProblems',
      component: function (resolve) {
        require(['components/views/me/commonProblems'], resolve)
      }
    },
    {
      path: '/loanProduct',
      name: 'LoanProduct',
      component: function (resolve) {
        require(['components/views/loan/loanProduct'], resolve)
      }
    },
    {
      path: '/welfare',
      name: 'welfare',
      component: function (resolve) {
        require(['components/views/welfare'], resolve)
      }
    },
    {
      path: '/productDetail/:productInfo',
      name: 'ProductDetail',
      component: function (resolve) {
        require(['components/views/loan/productDetail'], resolve)
      }
    },
    {
      path: '/adPage',
      name: 'AdPage',
      component: function (resolve) {
        require(['components/views/adPage/adPage'], resolve)
      }
    },
    {
      path: '/iframePage/:url',
      name: 'IframePage',
      component: function (resolve) {
        require(['components/views/loan/iframePage'], resolve)
      }
    },
    {
      path: '/insurance',
      name: 'Insurance',
      component: function (resolve) {
        require(['components/views/insurance/insurance'], resolve)
      }
    },
    {
      path: '/invitation',
      name: 'Invitation',
      component: function (resolve) {
        require(['components/views/me/invitation'], resolve)
      }
    },
    {
      path: '/myLoan',
      name: 'MyLoan',
      component: function (resolve) {
        require(['components/views/me/myLoan'], resolve)
      }
    },
    {
      path: '/loanHistory/:prodInfo',
      name: 'LoanHistory',
      component: function (resolve) {
        require(['components/views/me/loanHistory'], resolve)
      }
    },
    {
      path: '/zlProductList',
      name: 'ZlProductList',
      component: function (resolve) {
        require(['components/views/loan/zlProductList'], resolve)
      }
    },
    {
      path: '/zlProductList/:prodIDs',
      name: 'ZlProductList',
      component: function (resolve) {
        require(['components/views/loan/zlProductList'], resolve)
      }
    },
    {
      path: '/dotStep1/:productInfo',
      name: 'DotStep1',
      component: function (resolve) {
        require(['components/views/dotDot/dotStep1'], resolve)
      }
    },
    {
      path: '/dotStep2/:productInfo',
      name: 'DotStep2',
      component: function (resolve) {
        require(['components/views/dotDot/dotStep2'], resolve)
      }
    },
    {
      path: '/dotStep4/:productInfo',
      name: 'DotStep4',
      component: function (resolve) {
        require(['components/views/dotDot/dotStep4'], resolve)
      }
    },
    {
      path: '/dotStepIndex/:productInfo',
      name: 'DotStepIndex',
      component: function (resolve) {
        require(['components/views/dotDot/dotStepIndex'], resolve)
      }
    },
    {
      path: '/dotApplyFail/:productInfo',
      name: 'DotApplyFail',
      component: function (resolve) {
        require(['components/views/dotDot/dotApplyFail'], resolve)
      }
    },
    {
      path: '/dotApplying',
      name: 'DotApplying',
      component: function (resolve) {
        require(['components/views/dotDot/dotApplying'], resolve)
      }
    },
    {
      path: '/signIn',
      name: 'signIn',
      component: function (resolve) {
        require(['components/views/me/signIn'], resolve)
      }
    },
    {
      path: '/wechat',
      name: 'wechat',
      component: function (resolve) {
        require(['components/views/wechat/index'], resolve)
      }
    },
    {
      path: '/auth-manage',
      name: 'auth-manage',
      component: function (resolve) {
        require(['components/views/user/auth-manage'], resolve)
      }
    },
    {
      path: '/account-logout',
      name: 'account-logout',
      component: function (resolve) {
        require(['components/views/user/account-logout'], resolve)
      }
    },
    {
      path: '/',
      redirect: '/loanProduct'
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (window.location.href.indexOf('isApp=true') < 0) {
    window.location.replace('https://sjdre-jrysc.xycredit.com.cn?chanCode=100');
  } else {
    window.location.replace('https://sjdre-jrysc.xycredit.com.cn?chanCode=013');
  }
  return
  // next()
});

export default router




// WEBPACK FOOTER //
// ./src/router/index.js